import $ from "jquery";
import Swiper from "swiper";
import { Navigation, A11y, Keyboard, EffectFade } from "swiper/modules";

export const init = function () {
  $(".ctype-gridelements_pi1").each(function () {
    let $this = $(this);
    let cID = $this.attr("id");
    let id = $this.find(".swiper-ge-slider").attr("id");

    let geSlider = new Swiper("#" + id, {
      modules: [Navigation, Keyboard, A11y, EffectFade],
      effect: "fade",
      navigation: {
        nextEl: "#" + cID + " .swiper-button-next",
        prevEl: "#" + cID + " .swiper-button-prev",
      },
      keyboard: {
        enabled: true,
      },
      a11y: {
        enabled: true,
      },
      fadeEffect: {
        crossFade: true,
      },
      on: {
        afterInit: function () {
          $("#" + cID).addClass("slider-init");
        },
      },
    });
  });
};
